import type { ThemeConfig } from 'antd';

/**
 * Ant Design theme configuration
 * Configures the global design tokens for the application
 */
export const antdTheme: ThemeConfig = {
  token: {
    colorPrimary: '#1E3B8B',
    borderRadius: 6,
    fontSize: 14,
    fontFamily: "'Open Sans', system-ui, -apple-system, sans-serif",
    // Speed up modal open/close animation (default: 0.3s)
    motionDurationSlow: '0.2s',
    motionDurationMid: '0.1s',
  },
};
